const info = [
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'akash',
            client_id: '07-tendermint-47',
            connection_id: 'connection-22'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-20',
            connection_id: 'connection-9'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-13',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-7',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cosmoshub',
            client_id: '07-tendermint-386',
            connection_id: 'connection-340'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-27',
            connection_id: 'connection-24'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-185',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-11',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'cryptoorgchain',
            client_id: '07-tendermint-732',
            connection_id: 'connection-218'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-28',
            connection_id: 'connection-26'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-25',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-12',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'irisnet',
            client_id: '07-tendermint-35',
            connection_id: 'connection-26'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-25',
            connection_id: 'connection-22'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-16',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-9',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'kujira',
            client_id: '07-tendermint-106',
            connection_id: 'connection-76'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-115',
            connection_id: 'connection-104'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-68',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-100',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'osmosis',
            client_id: '07-tendermint-6',
            connection_id: 'connection-7'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-1',
            connection_id: 'connection-1'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-8',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-1',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true,
                    dex: 'osmosis'
                }
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'persistence',
            client_id: '07-tendermint-33',
            connection_id: 'connection-27'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-30',
            connection_id: 'connection-28'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-21',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-14',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'quicksilver',
            client_id: '07-tendermint-16',
            connection_id: 'connection-9'
        },
        chain_2: {
            chain_name: 'regen',
            client_id: '07-tendermint-113',
            connection_id: 'connection-102'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-17',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-61',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1'
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'regen',
            client_id: '07-tendermint-31',
            connection_id: 'connection-29'
        },
        chain_2: {
            chain_name: 'sentinel',
            client_id: '07-tendermint-56',
            connection_id: 'connection-32'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-15',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-11',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'regen',
            client_id: '07-tendermint-73',
            connection_id: 'connection-60'
        },
        chain_2: {
            chain_name: 'sifchain',
            client_id: '07-tendermint-31',
            connection_id: 'connection-13'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-28',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-10',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'regen',
            client_id: '07-tendermint-74',
            connection_id: 'connection-61'
        },
        chain_2: {
            chain_name: 'starname',
            client_id: '07-tendermint-45',
            connection_id: 'connection-31'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-29',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-14',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {}
            }
        ]
    },
    {
        $schema: '../ibc_data.schema.json',
        chain_1: {
            chain_name: 'regen',
            client_id: '07-tendermint-176',
            connection_id: 'connection-148'
        },
        chain_2: {
            chain_name: 'umee',
            client_id: '07-tendermint-239',
            connection_id: 'connection-200'
        },
        channels: [
            {
                chain_1: {
                    channel_id: 'channel-158',
                    port_id: 'transfer'
                },
                chain_2: {
                    channel_id: 'channel-107',
                    port_id: 'transfer'
                },
                ordering: 'unordered',
                version: 'ics20-1',
                tags: {
                    status: 'live',
                    preferred: true
                }
            }
        ]
    }
];
export default info;
